import {
  CURRENCY_CONVERSION_SUCCESS,
  CURRENCY_CONVERSION_INVALID_REQUEST,
  RESET_CURRENCY_CONVERSION,
} from "../types";

const initialState = {
  invalidRequest: false,
  success: false,
  networkError: "",
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CURRENCY_CONVERSION_INVALID_REQUEST:
      return {
        ...state,
        success: false,
        invalidRequest: true,
        networkError: "",
        data: action.payload,
      };
    case CURRENCY_CONVERSION_SUCCESS:
      return {
        ...state,
        success: true,
        invalidRequest: false,
        networkError: "",
        data: action.payload,
      };

    case RESET_CURRENCY_CONVERSION:
      return (state = initialState);

    default:
      return state;
  }
};
